<template>
  <v-tooltip bottom :disabled="!attrs.tooltip">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon
        :class="btnClass"
        :color="attrs.color"
        @click.stop="$emit('click')"
      >
        <v-icon>{{ attrs.icon }}</v-icon>
      </v-btn>
    </template>
    {{ attrs.tooltip }}
  </v-tooltip>
</template>


<script>
export default {
  inheritAttrs: false,


  props: {
    type: {
      type: String
    },
    tooltip: {
      type: String
    },
    icon: {
      type: String
    },
    color: {
      type: String
    },
    btnClass: {
      type: undefined
    }
  },


  data () {
    return {
      presets: {
        view: {
          icon: 'mdi-eye',
          tooltip: this.$t('view')
        },
        edit: {
          icon: 'mdi-pencil-outline',
          tooltip: this.$t('edit')
        },
        delete: {
          icon: 'mdi-delete-outline',
          tooltip: this.$t('delete')
        },
        copy: {
          icon: 'mdi-content-copy',
          tooltip: this.$t('copy')
        },
        close: {
          icon: 'mdi-close',
          tooltip: this.$t('close')
        },
        clear: {
          icon: 'mdi-close',
          tooltip: this.$t('clear')
        },
        remove: {
          icon: 'mdi-close',
          tooltip: this.$t('remove')
        },
        lock: {
          icon: 'mdi-lock-outline',
          color: 'black'
        },
        download: {
          icon: 'mdi-file-outline',
          tooltip: this.$t('download'),
          color: 'black'
        },
        exportXlsx: {
          icon: 'mdi-microsoft-excel',
          tooltip: this.$t('exportXlsx')
        }
      }
    }
  },


  computed: {
    attrs () {
      const defaultAttrs = this.presets[this.type] || {}

      const attrs = {
        tooltip: this.tooltip || defaultAttrs.tooltip,
        icon: this.icon || defaultAttrs.icon,
        color: this.color || defaultAttrs.color
      }

      return attrs
    }
  }
}
</script>
